<img *ngIf="avatar; else initialsAvatar" [src]="avatar" />
<ng-template #initialsAvatar>
  <div class="avatar-circle" [style.background]="color">
    <span class="initials" [style.color]="textColor">{{ initials }}</span>
  </div>
</ng-template>

<!-- TODO: Remove this, attach outside with a badge or using content transclusion -->
<span class="online-marker" *ngIf="online"></span>
